var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m5.969 5.969.976 15.625c.047.903.703 1.562 1.563 1.562h8.984c.863 0 1.508-.66 1.563-1.562l.976-15.625"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.406 5.969h17.188z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M4.406 5.969h17.188"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M9.875 5.969V4.016a1.17 1.17 0 0 1 1.172-1.172h3.906a1.17 1.17 0 0 1 1.172 1.172v1.953M13 9.094V20.03M9.484 9.094l.391 10.937m6.64-10.937-.39 10.937"
})));
export default SvgIconRemove;